// src/components/Navbar.jsx
import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const sections = [
  { name: 'Home', path: '/' },
  { name: 'About', path: '/', hash: 'about' },
  { name: 'Experience', path: '/experience' },
  { name: 'Projects', path: '/projects' }, 
  { name: 'Resume', external: 'http://bit.ly/42XNDel'}, 
  { name: 'Contact', path: '/', hash: 'contact' },
];

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();

  const handleSectionClick = (section) => {
    if (section.hash) {
      // If we're already on the home page, just scroll to the section
      if (location.pathname === '/') {
        const element = document.getElementById(section.hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
      // If we're on a different page, navigate to home first, then scroll
      else {
        navigate('/');
        // Use setTimeout to ensure the page has rendered before scrolling
        setTimeout(() => {
          const element = document.getElementById(section.hash);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100);
      }
    }
  };

  return (
    <nav>
      {sections.map((sec) => {
        if (sec.path && !sec.hash) {
          return <Link key={sec.name} to={sec.path}>{sec.name}</Link>;
        }
        if (sec.hash) {
          return (
            <Link 
              key={sec.name} 
              to={`${sec.path}#${sec.hash}`}
              onClick={(e) => {
                e.preventDefault();
                handleSectionClick(sec);
              }}
            >
              {sec.name}
            </Link>
          );
        }
        if (sec.external) {
          return (
            <a
              key={sec.name}
              href={sec.external}
              target="_blank"
              rel="noopener noreferrer"
            >
              {sec.name}
            </a>
          );
        }
        return null;
      })}
    </nav>
  );
}
